<template>
    <b-container class="sensors-container pb-5" fluid="true">
<!--        <DamDataUpdater-->
<!--            v-if="currentDamSelected"-->
<!--            :key="currentDamSelectedName"-->
<!--        ></DamDataUpdater>-->

        <NameBar></NameBar>
        <TabsBar></TabsBar>
        <CentralDatePickerCharts v-if="activeTab === 1" :activeTabProp="1"></CentralDatePickerCharts>
        <CentralDatePickerCharts v-if="activeTab === 2" :activeTabProp="2"></CentralDatePickerCharts>
        <CentralDatePickerCharts v-if="activeTab === 3" :activeTabProp="3"></CentralDatePickerCharts>
        <CentralDatePickerCharts v-if="activeTab === 4" :activeTabProp="4"></CentralDatePickerCharts>
        <CentralDatePickerCharts v-if="activeTab === 6" :activeTabProp="6"></CentralDatePickerCharts>

        <ChartItemControllerContainer v-if="activeTab === 1"></ChartItemControllerContainer>
        <ChartItemPiezometersContainer v-if="activeTab === 2"></ChartItemPiezometersContainer>
        <ChartItemInclinometersContainer v-if="activeTab === 3"></ChartItemInclinometersContainer>
        <ChartItemLevelmetersContainer v-if="activeTab === 4"></ChartItemLevelmetersContainer>
        <ChartItemOverviewContainer v-if="activeTab === 6"></ChartItemOverviewContainer>
    </b-container>
</template>

<script>
    //import DamDataUpdater from "../shared/DamDataUpdater";
    // mixins
    import RouteWatcher from "../../mixins/RouteWatcher";
    // utils
    import {removeMxTooltips} from "../../utils/common";
    // constants
    import {sensorTabsAndProfileLen} from "../../constants/sensors-constants";
    // components
    import NameBar from "./NameBar";
    import TabsBar from "./TabsBar";
    import ChartItemControllerContainer from "./ChartControllerContainer";
    import ChartItemPiezometersContainer from "./ChartPiezometersContainer";
    import ChartItemInclinometersContainer from "./ChartInclinometersContainer";
    import ChartItemLevelmetersContainer from "./ChartLevelmetersContainer";
    import ChartItemOverviewContainer from "./ChartOverviewContainer";
    import CentralDatePickerCharts from "./CentralDatePickerCharts";

    /**
     * Top level component for sensors. Used by the View page.
     * Can use an updater to fetch information for the selected dam
     * as to keep it up to date.
     */

    export default {
        name: "SensorsContainer",
        mixins: [RouteWatcher],
        components: {
            //DamDataUpdater,
            NameBar,
            TabsBar,
            ChartItemControllerContainer,
            ChartItemPiezometersContainer,
            ChartItemInclinometersContainer,
            ChartItemLevelmetersContainer,
            ChartItemOverviewContainer,
            CentralDatePickerCharts
        },
        data() {
            return {
                sensorTabsAndProfileLen
            }
        },
        async mounted() {
            setTimeout(await removeMxTooltips, 500);
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/variables";
    @import "../../assets/scss/viewDetailsBtn";

    .sensors-container {
        padding: 0 1.3rem;
        min-height: 90vh;
        position: relative;
    }
    .profile-btn-container {
        position: absolute;
        padding: 0 1.7rem;
        width: 100%;
        bottom: 10px;
        left: 50%;
        transform: translateX(-50%);
    }

    @media screen and (max-width: 762px) {
        .sensors-container {
            padding: 0 1rem;
        }
        .profile-btn-container {
            padding: 0 1rem;
        }
    }
</style>